import { Group, Text, Button, ActionIcon, Select, Input, Box, Grid, Flex } from '@mantine/core';
import { IconTrash, IconCheck, IconX, IconCaretUpFilled, IconCaretDownFilled, IconSearch } from '@tabler/icons-react';
import React, { useState, useEffect } from 'react';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { useNavigate } from "react-router-dom";
import SettingsApi from "../../../api/SettingsApi";
import { SelectMemberWebsiteList, VisiLoader, HelpTip } from "../../GeneralComponent/GeneralComponent";

export function CustomTags({ SelectMemberWebsiteListValue }:any) {

	const navigate = useNavigate();
	const activeURLBuilder = 'Custom-tags';
	const [websitePageList, setWebsitePageList] = useState([]);
	const [customTagsData, setCustomTagsData] = useState([]);
	const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
	const [selectedPageValue, setSelectedPageValue] = useState('');
	const [customTagName, setCustomTagName] = useState('');
  const [visiLoaderVisible, setVisiLoaderVisible] = useState(false);

  const [sortKeyName, setSortKeyName] = useState('');
  const [sortingDirection, setSortingDirection] = useState('');
  const [sortedCustomTagsList, setSortedCustomTagsList] = useState([]);

	useEffect(() => {
  	if(SelectMemberWebsiteListValue !== ""){
  		setSelectedMemberWebsite(SelectMemberWebsiteListValue);
  	}
  }, [SelectMemberWebsiteListValue]);

	const fetchCustomTagDetails = () => {
		setVisiLoaderVisible(true);
		SettingsApi.getcustomtagdetails()
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setVisiLoaderVisible(false);
          }
        }
      })
      .then(data => {
        if(data.status === 1){       	
          setCustomTagsData(data.data);
          setSortedCustomTagsList(data.data);   
          setVisiLoaderVisible(false);
        }
      })
      .catch(error => {
        console.log(error);
        setVisiLoaderVisible(false);
      });
    };

	const deleteCustomTagConfirm = (deleteCustomTagId:any) => modals.openConfirmModal({
    trapFocus: false,
    title: 'Delete Custom Tag',
    children: (
      <Text size="sm">
        Are you sure you want to delete this Custom Tag?
      </Text>
    ),
    labels: { confirm: 'Delete Custom Tag', cancel: "No don't delete it" },
    confirmProps: { color: 'red' },
    onCancel: () => console.log('Cancel'),
    onConfirm: () => console.log('Confirmed',handleCustomTagDelete(deleteCustomTagId)),
  });


  const handleCustomTagDelete = (deleteCustomTagId:any) => {
  	setVisiLoaderVisible(true);
    SettingsApi.deletecustomtag({
      custom_tag_id: deleteCustomTagId,
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        }); 
        fetchCustomTagDetails();
        setVisiLoaderVisible(false);   
      }else{
      	notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.log(error);
      setVisiLoaderVisible(false);
    });
  }

  const handleMemberWebsiteChange = (e:any) => {
  		setSelectedMemberWebsite(e);			
  };

  const fetchMemberPages = () => {
  	SettingsApi.getwebsitepages({
	      system_website_id: selectedMemberWebsite,
        type:"source",
	    })
	    .then(response => {
	      if (response.ok) {
	        return response.json();
	      } else {
	        if (response.status === 401 || response.status === 400) {
	          navigate("/logout");
	        }
	      }
	    })
	    .then(data => {
	    	setWebsitePageList(data.data)
	    })
	    .catch(error => {
	      console.log(error);
	    });	
  };

  const handleAddCustomTag = (e:any) => {
  	e.preventDefault();  		
  	SettingsApi.addcustomtag({
      page_id:selectedPageValue,
  		custom_tag:customTagName,
  		system_website_id:selectedMemberWebsite
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });  
        setSelectedPageValue('');
        setCustomTagName('');
        fetchCustomTagDetails();   
      }else{
      	notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch(error => {
      console.log(error);
    });  	
  };

  useEffect(() => {
      fetchCustomTagDetails();
  },[]);

  useEffect(() => {
    if (selectedMemberWebsite) {
      fetchMemberPages(); 
    }
  }, [selectedMemberWebsite]);


  const handleSorting = (keyName: string) => {
    let newDirection = sortingDirection === 'desc' ? 'asc' : 'desc';
    setSortingDirection(newDirection);
    setSortKeyName(keyName);
    
    const sortedList = [...customTagsData].sort((a, b) => {
      if (!keyName) return 0;

      const valueA = a[keyName]?.toString().toLowerCase() || '';
      const valueB = b[keyName]?.toString().toLowerCase() || '';

      if (valueA < valueB) return newDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setSortedCustomTagsList(sortedList);
  };

  const handleKeywordChange = (e) => {
    const keyword = e.target.value;

    const filteredList = customTagsData.filter(data =>
      data.custom_tag?.toLowerCase().includes(keyword.toLowerCase())
    );

    setSortedCustomTagsList(filteredList);
  };

	return (
		<>  	
			<VisiLoader VisiLoaderVisible={visiLoaderVisible} />
			<div style={{ display: activeURLBuilder === "Custom-tags" ? "block" : "none"}}>
				<Group position="apart" mb="xs">
		      <Text weight={500}>CUSTOM TAGS <HelpTip helpId={231} /></Text>
		    </Group>
		    <form onSubmit={handleAddCustomTag}>
			    <Group mb={15}>		    		
		          <Text fw={500}>Select domain :</Text>
		          <SelectMemberWebsiteList SelectMemberWebsiteListValue={selectedMemberWebsite} SelectMemberWebsiteListOnChange={handleMemberWebsiteChange} SelectMemberWebsiteListWidth={250} SelectMemberWebsiteListUsedIn="settings" SelectMemberWebsiteListMaxDropdownHeight={300} SelectMemberWebsiteListdropdownPosition="bottom" SelectMemberWebsiteListML={4}/>
		          <Text fw={500}>Page :</Text>
		          <Select
				        data={[
							    { value: '', label: 'Select Page' }, 
							    ...websitePageList.slice(1).map((page, index) => ({
							      value: page.page_id,
							      label: page.page_url
							    }))
							  ]}
				        value={selectedPageValue}
				        onChange={(value) => setSelectedPageValue(value)}	            
		          />
		      		<Input 
		      			w={200} 
		      			ml={0} 
		      			placeholder='Custom Tag' 
		      			value={customTagName} 
		      			onChange={(e) => setCustomTagName(e.target.value)} 
		      		/>	
		      		<Button type="submit" size="sm" w={80}>
	             Save
	          </Button>	      	         
		      </Group>
		    </form>
        {customTagsData.length > 0 && (
          <Box
            p={4}
            pl={20}
            mt={10}
            sx={(theme) => ({
              padding: "10px",
              borderRadius: theme.radius.md,
              fontWeight: "bold",
            })}
          >
          {customTagsData.some(item => Array.isArray(item) ? item.length > 0 : true) && (
            <Grid gutter="xs">
              <Grid.Col span={3}>
                <Text mt={3} weight={500} onClick={() => handleSorting('custom_tag')}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                    {'Custom Tag'}
                    {sortKeyName === 'custom_tag' && (
                      sortingDirection === 'asc' ? <IconCaretUpFilled /> : <IconCaretDownFilled />
                    )}
                  </span>
                </Text>
              </Grid.Col>
              <Grid.Col span={3}>
                <Text mt={3} weight={500} onClick={() => handleSorting('domain_name')}>                  
                  <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                    {'Domain'}
                    {sortKeyName === 'domain_name' && (
                      sortingDirection === 'asc' ? <IconCaretUpFilled /> : <IconCaretDownFilled />
                    )}
                  </span>
                </Text>
              </Grid.Col>
              <Grid.Col span={3}>
                <Text mt={3} weight={500} onClick={() => handleSorting('title')}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                    {'Page Name'}
                    {sortKeyName === 'title' && (
                      sortingDirection === 'asc' ? <IconCaretUpFilled /> : <IconCaretDownFilled />
                    )}
                  </span>
                </Text>
              </Grid.Col>
              <Grid.Col span={3}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Input icon={<IconSearch size={16} />} 
                    placeholder="Search"
                    maxLength={50}
                    autoFocus
                    onChange={handleKeywordChange}
                    style={{ maxWidth: "250px" }}
                  />
                </div>
              </Grid.Col>
            </Grid>
          )}
          </Box>
        )}
        {sortedCustomTagsList.map((item,index) => (
            <Box
             key={index}
              p={4}
              pl={20}
              mt={10}
              sx={(theme) => ({
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#f8f9fa',
                padding: "10px",
                borderRadius: theme.radius.md,
                border: "0.0625rem solid transparent",
                borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[1] : '#dee2e6'
              })}
            >
              <Grid gutter="xs">
                <Grid.Col span={3}>
                  <Text mt={3}>
                    {item.custom_tag}
                  </Text>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text mt={3}>
                    {item.domain_name}
                  </Text>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text mt={3}>
                    {item.title}
                  </Text>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Flex
                    justify="flex-end"
                    align="center"
                    direction="row"
                    wrap="wrap"
                  >
                    <ActionIcon
                      variant="default"
                      size="lg"
                      mx={3}
                      title="Delete"
                      onClick={() => deleteCustomTagConfirm(item.custom_tag_id)}
                    >
                      <IconTrash size="1.1rem" />
                    </ActionIcon>
                  </Flex>
                </Grid.Col>
              </Grid>
            </Box>
          )
        )}
	      </div>
		</>
	);
}